import axiosInstance from '@/utils/axiosConfig'; // Importer l'instance Axios configurée
import axios from 'axios';

const ZoneService = {
    async getAllZones(): Promise<any | { status: number; message: string }> {
        try {
            const response = await axiosInstance.get('/zones/all_zone/');
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                return {
                    status: error.response?.status ?? 500,
                    message: error.response?.data?.message ?? 'An error occurred while fetching zones.'
                };
            }
            return {
                status: 500,
                message: 'An unexpected error occurred.'
            };
        }
    },
    
    async getZonesByLocation(id: number): Promise<any | { status: number; message: string }> {
        try {
            const response = await axiosInstance.get(`/zones/location/${id}`);
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                return {
                    status: error.response?.status ?? 500,
                    message: error.response?.data?.message ?? 'An error occurred while fetching zones by location.'
                };
            }
            return {
                status: 500,
                message: 'An unexpected error occurred.'
            };
        }
    },
};

export default ZoneService;
